import { render } from "./SidebarMenuItemBot4.vue?vue&type=template&id=57603c04&scoped=true"
import script from "./SidebarMenuItemBot4.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemBot4.vue?vue&type=script&lang=js"

import "./SidebarMenuItemBot4.vue?vue&type=style&index=0&id=57603c04&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57603c04"]])

export default __exports__